import React from 'react';
import { DealerStaticViewer } from '@wix/react-dealer-viewer';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import CloseIconBold from '@wix/da-ds/pkg/Icons/CloseBold';
import ButtonB5 from '@wix/da-shared-react/pkg/Button/ButtonB5';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useDealerBanners } from './useDealerBanners';

import s from './DealerAd.scss';

export interface Props {
  realEstateId: string;
  userGuid: string;
  biClientId: string;
  biClientIdSigned: string;
  additionalParams?: { [s: string]: string }; // TODO remove if we dont use it
  withCloseButton: boolean;
  translationVersion: string;
}

const DealerAd: React.FC<Props> = ({
  realEstateId,
  userGuid = '',
  additionalParams,
  biClientId,
  withCloseButton,
  translationVersion,
  biClientIdSigned,
}) => {
  const { isEmpty, isLoaded, offers, onEmpty, closeOffer } = useDealerBanners(
    realEstateId,
    biClientIdSigned,
    userGuid
  );

  if (isEmpty || (isLoaded && !offers.length)) {
    return null; // collapse
  }

  const offer = offers[0];
  return (
    <ErrorBoundary>
      <div className={s['root']}>
        {isLoaded && (
          <div key={offer.offerGuid} className={s['banner-wrapper']}>
            <DealerStaticViewer
              dealerOptions={additionalParams}
              bannerPosition={realEstateId}
              locale="en"
              metasiteGuid=""
              translationsUrl={`https://static.parastorage.com/services/dealer-cms-translations/${translationVersion}/`}
              offer={offer}
              additionalBiParams={{
                _uuid: userGuid || '',
                uuid: userGuid || '',
                client_id: biClientId || '',
              }}
              onEmpty={onEmpty}
              onError={onEmpty}
            />

            {withCloseButton && (
              <ButtonB5
                className={s['close-button']}
                icon={CloseIconBold}
                iconProps={{ size: IconSize.MEDIUM }}
                onClick={() => closeOffer(offer)}
                biData={{
                  evid: BiEventType.CLOSE_BANNER_AD,
                  realestateid: realEstateId,
                  campaignid: offer.offerGuid,
                }}
              />
            )}
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};
DealerAd.displayName = 'DealerAd';

// we just don't care for prop changes, period
export default React.memo(DealerAd, () => true);
